import Head from 'next/head';
import Link from 'next/link';
import { TFunction } from 'next-i18next';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONDITION_DESKTOP, SUPPORT_EMAIL, SUPPORT_TELEGRAM } from 'shared/common/constants';
import { routes } from 'shared/common/routes';
import styled from 'styled-components';
import { MainLayout } from 'widgets/layouts';

const getNavbar = (t: TFunction) => [
  {
    text: t('defaultNavbar.findExperts'),
    href: routes.topics,
  },
  {
    text: t('defaultNavbar.becomeExpert'),
    href: routes.expertLanding,
  },
];

export const Contacts: FC = () => {
  const { t } = useTranslation('header.component');

  return (
    <MainLayout hasFooter head={{ title: 'Контакты' }} navbar={getNavbar(t)} isLoginButtonVisible>
      <Head>
        <meta name="title" content="Контакты" />
        <meta name="description" content="Контакты" />
        <meta name="og:title" content="Контакты" />
        <meta name="og:site_name" content="www.consulty.online" />
        <meta name="og:url" content="https://www.consulty.online/academy/" />
        <meta name="og:description" content="Контакты" />
      </Head>

      <h1 className="hidden">{t('head.title')}</h1>
      <Content className="container">
        <StyledHeading>Контакты</StyledHeading>
        <p>По всем вопросам пишите:</p>
        <StyledItemHeading>Telegram</StyledItemHeading>
        <Link href={`https://t.me/${SUPPORT_TELEGRAM}`}>
          <a>{`@${SUPPORT_TELEGRAM}`}</a>
        </Link>
        <StyledItemHeading>Почта</StyledItemHeading>
        <Link href={`mailto:${SUPPORT_EMAIL}`}>
          <a>{SUPPORT_EMAIL}</a>
        </Link>
        <StyledItemHeading>В чат </StyledItemHeading>
        <p>на сайте справа внизу.</p>
        <ContentFooter>
          <Note>
            <p>В рабочие дни отвечаем с 10:00 до 20:00 в течение часа.</p>
            <p>В остальное время мы тоже на связи, но отвечать можем значительно дольше.</p>
          </Note>
          <p>Скоро это изменится, и поддержка заработает круглосуточно 🙌</p>
        </ContentFooter>
      </Content>
    </MainLayout>
  );
};

const Note = styled.div`
  margin-bottom: 18px;
  ${CONDITION_DESKTOP} {
    margin-bottom: 28px;
  }
`;

const Content = styled.main`
  ol {
    line-height: 1.4;
    > li {
      margin-bottom: 10px;
      white-space: break-spaces;
    }
  }
  a {
    color: #8b33ff;
  }
  margin-bottom: 80px;
`;

const ContentFooter = styled.div`
  padding-top: 60px;
`;

const StyledHeading = styled.h2`
  font-size: 24px;
  color: var(--black2);
  padding: 30px 0 30px;
  ${CONDITION_DESKTOP} {
    padding-top: 60px;
    padding-bottom: 30px;
    text-align: left;
    font-size: 36px;
  }
`;

const StyledItemHeading = styled.h2`
  font-size: 18px;
  color: var(--black2);
  padding: 6px 0 6px;
  ${CONDITION_DESKTOP} {
    padding-top: 30px;
    padding-bottom: 5px;
    text-align: left;
    font-size: 25px;
  }
`;
